import React, { useState } from "react";
import { useTheme } from "styled-components";
import "react-color-palette/lib/css/styles.css";

import { ColorPicker as Picker } from "@caelor/ui";

import { themes } from "../../../theme-colors";
import { useOpticsStore } from "../../../stores/use-optics-store";
import { DEFAULT_COLORS } from "../../../styleguide/onboarding/components/ui/color-pair/templates/colors";

const ColorPicker = ({
  value,
  hideColorTiles,
  onChange = () => {},
  hasOpacity,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { selectedColors } = useOpticsStore((state) => state.styleguideSetup);

  const theme = useTheme();

  return (
    <Picker
      value={value}
      selectedColors={selectedColors}
      defaultColors={DEFAULT_COLORS}
      additionalStyle={{ padding: "0 13px 0 0" }}
      containerStyles={{ top: "75px" }}
      hideColorTiles={hideColorTiles}
      hasOpacity={hasOpacity}
      theme={theme.name}
      isOpen={isOpen}
      onChange={onChange}
      setIsOpen={(value) => {
        setIsOpen(value);

        if (!value) {
          window.AP.events.emit("theme-changed", null);
        }
      }}
      onThemeChange={(mode) =>
        window.AP.events.emit("theme-changed", themes[mode])
      }
    />
  );
};

export default ColorPicker;
